export default __webpack_public_path__ + "static/media/metamask.8a98fd5d.svg";